module.exports = __webpack_public_path__ + "static/media/0015.20b22c04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48010/RAL/0015.png
// module id = 429
// module chunks = 0